module.exports = __webpack_public_path__ + "img/blueCross.0dcb4d51.svg";